/**
 * ware-email-popup
 * Fires after configurable delay. Suppresses for 30 days via localStorage.
 */
class WareEmailPopup extends HTMLElement {
  connectedCallback() {
    this._backdrop = document.querySelector('.ware-email-popup-backdrop');
    this._closeBtn = this.querySelector('[data-popup-close]');
    this._dismissBtn = this.querySelector('[data-popup-dismiss]');
    this._form = this.querySelector('[data-popup-form]');
    this._emailInput = this.querySelector('[data-popup-email]');

    const delay = parseInt(this.dataset.delay || '5', 10) * 1000;
    const suppressionDays = parseInt(this.dataset.suppression || '30', 10);
    const storageKey = 'ware_popup_seen';

    const seen = localStorage.getItem(storageKey);
    if (seen) {
      const seenDate = new Date(parseInt(seen, 10));
      const daysSince = (Date.now() - seenDate.getTime()) / (1000 * 60 * 60 * 24);
      if (daysSince < suppressionDays) return;
    }

    setTimeout(() => this._open(), delay);

    if (this._closeBtn) {
      this._closeBtn.addEventListener('click', () => this._close());
    }
    if (this._dismissBtn) {
      this._dismissBtn.addEventListener('click', () => this._close());
    }
    if (this._backdrop) {
      this._backdrop.addEventListener('click', () => this._close());
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) {
        this._close();
      }
    });

    if (this._form) {
      this._form.addEventListener('submit', (e) => this._handleSubmit(e));
    }
  }

  _open() {
    this.classList.add('is-open');
    if (this._backdrop) this._backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.setAttribute('aria-hidden', 'false');
    if (this._emailInput) this._emailInput.focus();
  }

  _close() {
    this.classList.remove('is-open');
    if (this._backdrop) this._backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    this.setAttribute('aria-hidden', 'true');
    localStorage.setItem('ware_popup_seen', Date.now().toString());
  }

  async _handleSubmit(e) {
    e.preventDefault();
    const email = this._emailInput ? this._emailInput.value : '';
    if (!email) return;

    const submitBtn = this._form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;
    }

    try {
      // Post to Shopify customer endpoint
      const formData = new FormData(this._form);
      await fetch('/contact#contact_form', {
        method: 'POST',
        body: formData
      });
    } catch (e) {
      // Silently fail — still show success to not frustrate user
    }

    const discountCode = this.dataset.discountCode || 'WARE10';
    const contentEl = this.querySelector('[data-popup-content]');
    if (contentEl) {
      contentEl.innerHTML = `
        <p class="ware-email-popup__eyebrow">You're in</p>
        <h3 class="ware-email-popup__heading">Use code ${discountCode} at checkout.</h3>
        <p class="ware-email-popup__dek">Your discount code has been sent to ${email}. It never expires.</p>
      `;
    }

    setTimeout(() => this._close(), 3000);
  }
}

customElements.define('ware-email-popup', WareEmailPopup);
